const Urls = {
  AWS_BUCKET: "https://nftgame-characters.s3.amazonaws.com/",
};
const Contracts = {
  XPNET_TOKENS: "0x777929310d7a5F0eFFBE5834fF05719057ABe37A",
};
export { Urls, Contracts };
